// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import keycode from 'keycode'
import objectFitImages from 'object-fit-images'

// Internal Dependencies:
import { getScrollbarWidth } from 'utilities/scrollbar'
import Slider from 'components/slider/slider'
import Share from 'components/share/share'

// Redux:
import { setSelectedAnimal, setAnimalsFilter } from 'actions/animals'
import { selectedAnimal } from 'selectors/animals'

class AnimalSelected extends React.Component {
	componentDidMount() {
		document.addEventListener( 'keydown', this.handleKeyPress )
		this.scrollbarWidth = getScrollbarWidth()

		// Close on back:
		// window.onpopstate = () => {
		// 	this.handleClose()
		// }
	}

	componentDidUpdate() {
		const { selectedAnimal, subpage, filters } = this.props

		if ( selectedAnimal ) {
			document.documentElement.classList.add( 'with-animal-selected' )
			document.documentElement.style.paddingRight = this.scrollbarWidth + 'px'

			objectFitImages()
		} else {
			document.documentElement.classList.remove( 'with-animal-selected' )
			document.documentElement.style.paddingRight = 0
		}

		if ( subpage && filters && filters['shelter'] != subpage ) {
			this.props.setAnimalsFilter( 'shelter', subpage )
		}
	}

	componentWillUnmount() {
		document.removeEventListener( 'keydown', this.handleKeyPress )
		document.documentElement.classList.remove( 'with-animal-selected' )
		document.documentElement.style.paddingRight = 0
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleClose()
		} else if ( 'left' == keycode( e ) ) {
			this.selectAdjacent( false )
		} else if ( 'right' == keycode( e ) ) {
			this.selectAdjacent( true )
		}
	}

	handleClose = () => {
		const { match, setSelectedAnimal } = this.props
		const url = '/' + match.params.page + '/'

		setSelectedAnimal( false )

		window.history.pushState( { showAnimal: false }, '', url )
	}

	selectAdjacent = ( isNext ) => {
		const { selectedAnimal, filteredAnimalsIds, match } = this.props

		let i = filteredAnimalsIds.indexOf( selectedAnimal.id ),
			adjacentId

		if ( isNext ) {
			adjacentId = i !== -1 && filteredAnimalsIds[ i + 1 ]
		} else {
			adjacentId = i !== -1 && filteredAnimalsIds[ i - 1 ]
		}

		if ( adjacentId ) {
			const url = '/' + match.params.page + '/animal/' + adjacentId

			history.pushState( { showAnimal: true }, '', url )

			this.props.setSelectedAnimal( adjacentId )
		}
	}

	getAdjacentId = ( isNext ) => {
		const { selectedAnimal, filteredAnimalsIds } = this.props

		let i = filteredAnimalsIds.indexOf( selectedAnimal.id ),
			adjacentId

		if ( isNext ) {
			adjacentId = i !== -1 && filteredAnimalsIds[ i + 1 ]
		} else {
			adjacentId = i !== -1 && filteredAnimalsIds[ i - 1 ]
		}

		return adjacentId
	}

	render() {
		const { selectedAnimal, match } = this.props
		let pagePath = '/' + match.params.page

		if ( match.params.subpage ) {
			pagePath += '/' + match.params.subpage
		}

		const animalUrl = safeSiteData.site_url + pagePath + '/animal/' + selectedAnimal.id + '/'
		const closeUrl = pagePath + '/#all'
		const prevUrl = pagePath + '/animal/' + this.getAdjacentId( false ) + '/'
		const nextUrl = pagePath + '/animal/' + this.getAdjacentId( true ) + '/'

		if ( ! selectedAnimal ) {
			return (
				<div>
					<div className="selected-animal-overlay"></div>
					<div className="selected-animal">

					</div>
				</div>
			)
		}

		const { code, name, content, url, image_url, tagline, sex, breed, shelter, shelter_id, age, adopt_form_id, adopt_form_field_id } = selectedAnimal
		let { image_gallery } = selectedAnimal
		// let actionUrl = `https://service.sheltermanager.com/asmservice?account=${shelter_id}&method=online_form_html&formid=${adopt_form_id}&${adopt_form_field_id}=${name + ' ' + code}`
		let actionUrl = '/apply-to-adopt'
		let className = 'selected-animal is-active'

		if ( 'dog' === selectedAnimal.type ) {
			image_gallery.push( `${safeSiteData.images_url}animals/ecanis-info.png` )
		}

		if ( 'cat' === selectedAnimal.type && 'Karratha' === shelter ) {
			image_gallery.push( `${safeSiteData.images_url}animals/inside-cat.jpg` )
		}

		if ( image_gallery && image_gallery.length ) {
			className += ' with-slider'
		}

		return (
			<div>
				<div onClick={ this.handleClose }>
					<div className="selected-animal-overlay is-active"></div>
				</div>

				<div className={ className }>
					<div className="-inner">
						<div className="-image">
							<img src={ image_url } alt={ name } />

							<Slider images={ image_gallery } />
						</div>

						<div className="-info">
							<h3>{ name } <span>(Tag: { code })</span></h3>

							<p>
								{ tagline &&
									<span>
										<span className="-tagline" dangerouslySetInnerHTML={ { __html: tagline } } />
										<br />
									</span>
								}

								{ sex }, { breed }
								<br />
								{ age }
							</p>

							<div className="-badges">
								{ selectedAnimal.is_desexed &&
									<div className="-is-desexed">
										{ 'Male' == sex &&
											<i className="icon-mars-stroke-solid" aria-hidden="true" />
										||
											<i className="icon-neuter-solid" aria-hidden="true" />
										}

										<span>Desexed</span>
									</div>
								}

								{ selectedAnimal.is_microchipped &&
									<div className="-is-microchipped">
										<i className="icon-microchip-solid" aria-hidden="true" />
										<span>Microchipped</span>
									</div>
								}

								{ selectedAnimal.is_vaccinated &&
									<div className="-is-vaccinated">
										<i className="icon-syringe-solid" aria-hidden="true" />
										<span>Vaccinated</span>
									</div>
								}
							</div>

							<div className="-share">
								<span className="-share-text">Share on:</span>

								<Share type="facebook" url={ animalUrl }>
									<i className="icon-facebook-square" aria-hidden="true"></i>
								</Share>

								<Share type="twitter" url={ animalUrl }>
									<i className="icon-twitter-square" aria-hidden="true"></i>
								</Share>

								<Share type="google-plus" url={ animalUrl }>
									<i className="icon-google-plus" aria-hidden="true"></i>
								</Share>

								<Share type="email" url={ animalUrl }>
									<i className="icon-envelope-square" aria-hidden="true"></i>
								</Share>
							</div>

							<div className="-text">
								<div dangerouslySetInnerHTML={ { __html: content } } />

								<p>6 GREAT REASONS TO ADOPT FROM SAFE:</p>

								<p>
									✔ Lifetime Support: If you can no longer care for your adopted pet, please inform SAFE, and we will do our best to help you find a suitable solution.<br />
									✔ Discounted airfares: if applicable<br />
									✔ Adoption fee includes vet check, first vaccination, microchip and desexing<br />
									✔ Foster care instead of cage confinement, ensuring lots of love and socialisation<br />
									✔ Speak directly with my foster carer<br />
									✔ Quick response to your enquiry
								</p>

								<p>APPLY TO ADOPT ME</p>

								<p>Am I the one you have been looking for? Click the link and fill out the application with as much detail as possible. The more information you provide, the easier the adoption process will be, hopefully bringing us together sooner!</p>

								<p>
									Listed by SAFE { shelter }
								</p>
							</div>

							<nav>
								<Link to={ prevUrl }><i className="-back icon-chevron-down"></i></Link>
								<Link to={ nextUrl }><i className="-forward icon-chevron-down"></i></Link>
								<div onClick={ this.handleClose }><i className="-close icon-close"></i></div>
							</nav>
						</div>

						<div className="-action">
							<Link to={ actionUrl } className="button">Apply to Adopt</Link>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let animalsById

	switch ( ownProps.type ) {
		case 'cat':
			animalsById = state.animals.catsById

		case 'other':
			animalsById = state.animals.otherById

		default:
			animalsById = state.animals.dogsById
	}

	return {
		animalsById: animalsById,
		filteredAnimalsIds: state.animals.filteredAnimalsIds,
		selectedAnimal: selectedAnimal( state ),
		filters: state.animals.filters
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		setSelectedAnimal: ( id ) => {
			dispatch( setSelectedAnimal( id ) )
		},

		setAnimalsFilter: ( id, value ) => {
			dispatch( setAnimalsFilter( id, value ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( AnimalSelected )



// WEBPACK FOOTER //
// ./views/main/page/AnimalSelected.jsx